var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidelines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_637_706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 0H4.66665C2.82865 0 1.33331 1.49533 1.33331 3.33333V12.6667C1.33331 14.5047 2.82865 16 4.66665 16H11.3333C13.1713 16 14.6666 14.5047 14.6666 12.6667V3.33333C14.6666 1.49533 13.1713 0 11.3333 0ZM6.66665 12.6667C6.66665 13.0347 6.36798 13.3333 5.99998 13.3333H4.66665C4.29865 13.3333 3.99998 13.0347 3.99998 12.6667V11.3333C3.99998 10.9653 4.29865 10.6667 4.66665 10.6667H5.99998C6.36798 10.6667 6.66665 10.9653 6.66665 11.3333V12.6667ZM6.66665 8.66667C6.66665 9.03467 6.36798 9.33333 5.99998 9.33333H4.66665C4.29865 9.33333 3.99998 9.03467 3.99998 8.66667V7.33333C3.99998 6.96533 4.29865 6.66667 4.66665 6.66667H5.99998C6.36798 6.66667 6.66665 6.96533 6.66665 7.33333V8.66667ZM6.66665 4.66667C6.66665 5.03467 6.36798 5.33333 5.99998 5.33333H4.66665C4.29865 5.33333 3.99998 5.03467 3.99998 4.66667V3.33333C3.99998 2.96533 4.29865 2.66667 4.66665 2.66667H5.99998C6.36798 2.66667 6.66665 2.96533 6.66665 3.33333V4.66667ZM11.3333 12.6667H8.66665C7.79465 12.6627 7.79531 11.3373 8.66665 11.3333H11.3333C12.2053 11.3373 12.2046 12.6627 11.3333 12.6667ZM11.3333 8.66667H8.66665C7.79465 8.66267 7.79531 7.33733 8.66665 7.33333H11.3333C12.2053 7.33733 12.2046 8.66267 11.3333 8.66667ZM11.3333 4.66667H8.66665C7.79465 4.66267 7.79531 3.33733 8.66665 3.33333H11.3333C12.2053 3.33733 12.2046 4.66267 11.3333 4.66667Z",
    fill: "#B0B0B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_637_706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelines);
export default __webpack_public_path__ + "static/media/guidelines.7d837bb56bd764afbeb0e9504ffade49.svg";
export { ForwardRef as ReactComponent };